import { androidExternalBrowserUrl, detectKakaoBrowser } from '../../kakao-browser';

export type PhonePlatform = 'iphone' | 'android';

export interface UiEnvironment {
  /** Phones and tablets: the e-mail card is shown (and recommended) first. */
  readonly mobile: boolean;
  /** Default tab for the e-mail steps. */
  readonly phonePlatform: PhonePlatform;
  /** KakaoTalk in-app browser: file picking and image saving may be blocked. */
  readonly kakaoInApp: boolean;
  readonly kakaoInAppIos: boolean;
  /** Android intent URL that asks the system to open the page in a real browser. */
  readonly externalBrowserUrl: string | null;
  /** Canonical page URL used for copy-to-clipboard guidance. */
  readonly pageUrl: string;
}

export const TOOL_PATH = '/tools/kakao-report-card/';
export const TOOL_URL = `https://oneultool.com${TOOL_PATH}`;

/**
 * Pure device detection from the user agent. iPadOS reports a Mac user agent,
 * so touch points decide between a Mac and an iPad.
 */
export function detectUiEnvironment(userAgent: string, maxTouchPoints = 0, pageUrl = TOOL_URL): UiEnvironment {
  const ios = /iPhone|iPad|iPod/i.test(userAgent) || (/Macintosh/i.test(userAgent) && maxTouchPoints > 1);
  const android = /Android/i.test(userAgent);
  const kakao = detectKakaoBrowser(userAgent);
  let externalBrowserUrl: string | null = null;
  if (kakao.isAndroid) {
    try {
      externalBrowserUrl = androidExternalBrowserUrl(pageUrl);
    } catch {
      externalBrowserUrl = null;
    }
  }
  return {
    mobile: ios || android || /Mobi/i.test(userAgent),
    phonePlatform: ios ? 'iphone' : 'android',
    kakaoInApp: kakao.isKakao,
    kakaoInAppIos: kakao.isIOS || (kakao.isKakao && ios),
    externalBrowserUrl,
    pageUrl,
  };
}

/** Dev-only user agents for screenshot checks (?inapp=android|ios). */
export function previewUserAgent(kind: string | null): string | null {
  if (kind === 'android') return 'Mozilla/5.0 (Linux; Android 14) AppleWebKit/537.36 Chrome/128.0 Mobile Safari/537.36 KAKAOTALK/10.8.3 (INAPP)';
  if (kind === 'ios') return 'Mozilla/5.0 (iPhone; CPU iPhone OS 17_5_1 like Mac OS X) AppleWebKit/605.1.15 Mobile/15E148 KAKAOTALK/10.8.2 (INAPP)';
  return null;
}
